import { Object as FabricObject } from 'fabric/fabric-impl';
import {
  MediaManagerBoard,
  MediaManagerRenderedImage,
  MediaManagerTemplate,
} from 'modules/core/domain/interfaces/supabase/media-manager/entity';
import supabase from 'modules/core/supabase/supabase';

export interface UpdateBoardObjectsInput {
  id: number;
  objects: FabricObject[];
  version: string;
}

export interface PersistRenderedImageInput {
  matchId: number;
  boardId: number;
  dataUrl: string;
}

export class MediaManagerRepository {
  getTemplateWithBoards(templateId: number): Promise<{ template: MediaManagerTemplate; boards: MediaManagerBoard[] }> {
    return supabase.mediaManager.getTemplateWithBoards(templateId);
  }

  getTemplateById(id: number): Promise<MediaManagerTemplate> {
    return supabase.mediaManager.getTemplateById(id);
  }

  getBoardById(id: number): Promise<MediaManagerBoard> {
    return supabase.mediaManager.getBoardById(id);
  }

  updateBoardObjects(input: UpdateBoardObjectsInput): Promise<MediaManagerBoard> {
    return supabase.mediaManager.updateBoard({
      id: input.id,
      objects: input.objects,
      version: input.version,
    });
  }

  async persistRenderedImage(input: PersistRenderedImageInput): Promise<MediaManagerRenderedImage> {
    const { publicUrl } = await supabase.renderedImagesStorage.upload(
      input.matchId,
      input.boardId,
      input.dataUrl,
    );

    try {
      return await supabase.mediaManagerRenderedImages.upsert({
        matchId: input.matchId,
        boardId: input.boardId,
        imageUrl: publicUrl,
      });
    } catch (err) {
      await supabase.renderedImagesStorage.remove(publicUrl).catch((cleanupErr) => {
        console.error('[render] storage rollback failed', cleanupErr);
      });
      throw err;
    }
  }

  async deleteRenderedImage(id: string): Promise<void> {
    const row = await supabase.mediaManagerRenderedImages.getById(id);
    if (!row) return;

    await supabase.renderedImagesStorage.remove(row.imageUrl);
    await supabase.mediaManagerRenderedImages.deleteById(id);
  }
}

const mediaManagerRepository = new MediaManagerRepository();
export default mediaManagerRepository;
